import axios from "axios";
import "./Login.css";
import { useState } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { notificationActions } from "../../data/notification";
import useT from "../../i18n/useT";
import { Eye, EyeSlash, BoxArrowInRight, Search, ShieldLock, Truck, GraphUp } from "react-bootstrap-icons";

const Login = () => {
    const [formData, setFormData] = useState({ user: "", password: "" });
    const [showPassword, setShowPassword] = useState(false);
    const [keyCode, setKeyCode] = useState("");
    const [loading, setLoading] = useState({ login: false, getCar: false });
    const dispatch = useDispatch();
    const t = useT();

    const notify = (text, type) => {
        dispatch(notificationActions.changeNotification({ show: true, text, type }));
        setTimeout(() => dispatch(notificationActions.changeNotification({ show: false, text: "", type: "" })), 4000);
    };

    const handlers = {
        login(e) {
            e.preventDefault();
            setLoading((prev) => ({ ...prev, login: true }));
            axios.post("/api/login", formData)
                .then((res) => {
                    notify(res.data.message["en"], "success-notification");
                    setTimeout(() => { setLoading((prev) => ({ ...prev, login: false })); window.location.href = "/"; }, 900);
                })
                .catch((err) => {
                    setLoading((prev) => ({ ...prev, login: false }));
                    notify(err.response?.data?.message?.["en"] || "Login failed", "error-notification");
                });
        }
    };

    return (
        <div className="login-screen">
            <div className="login-hero">
                <div className="login-hero-inner">
                    <img src="/static/icons/logo.png" alt="Royal Motors" className="login-hero-logo" />
                    <h1>Royal Motors</h1>
                    <p className="login-hero-tag">{t("login.heroTag")}</p>
                    <ul className="login-hero-features">
                        <li><Truck /> {t("login.feature1")}</li>
                        <li><GraphUp /> {t("login.feature2")}</li>
                        <li><ShieldLock /> {t("login.feature3")}</li>
                    </ul>
                </div>
                <div className="login-hero-glow login-hero-glow-1"></div>
                <div className="login-hero-glow login-hero-glow-2"></div>
            </div>

            <div className="login-form-side">
                <div className="login-box">
                    <div className="login-box-brand">
                        <img src="/static/icons/logo.png" alt="Royal Motors" />
                    </div>
                    <h2>{t("login.signIn")}</h2>
                    <p className="login-box-sub">{t("login.welcome")}</p>

                    <form onSubmit={handlers.login} className="login-fields">
                        <div className="login-field">
                            <label>{t("login.usernameEmail")}</label>
                            <input value={formData.user} onChange={(e) => setFormData((prev) => ({ ...prev, user: e.target.value }))} type="text" placeholder={t("login.usernamePlaceholder")} className="form-control" />
                        </div>
                        <div className="login-field">
                            <label>{t("login.password")}</label>
                            <div className="login-password">
                                <input value={formData.password} onChange={(e) => setFormData((prev) => ({ ...prev, password: e.target.value }))} type={showPassword ? "text" : "password"} placeholder={t("login.passwordPlaceholder")} className="form-control" />
                                <button type="button" className="login-eye" onClick={() => setShowPassword(!showPassword)} aria-label="Toggle password">
                                    {showPassword ? <EyeSlash /> : <Eye />}
                                </button>
                            </div>
                        </div>
                        <div className="login-row-end">
                            <Link to="/reset-password">{t("login.forgot")}</Link>
                        </div>
                        <button disabled={loading.login} type="submit" className="btn btn-primary login-submit">
                            {loading.login ? <div className="spinner-border spinner-border-sm text-light" role="status"></div> : <><BoxArrowInRight /> {t("login.logIn")}</>}
                        </button>
                    </form>

                    <div className="login-divider"><span>{t("login.orSearch")}</span></div>

                    <form className="login-search" onSubmit={(e) => e.preventDefault()}>
                        <div className="login-search-field">
                            <Search className="login-search-icon" />
                            <input onChange={(e) => setKeyCode(e.target.value)} value={keyCode} placeholder={t("login.privateCode")} className="form-control" />
                        </div>
                        <button disabled={loading.getCar} className="btn btn-outline-primary login-search-btn">{t("common.search")}</button>
                    </form>
                </div>
                <p className="login-foot">© {new Date().getFullYear()} Royal Motors. {t("login.rights")}</p>
            </div>
        </div>
    );
};

export default Login;
